export interface SpecialtyCarrierConfig {
  name: string; // Carrier name to match in DB
  displayName: string; // Display name for UI
  lineOfBusiness: 'Auto' | 'Home'; // Line of business for filtering
  fileRequirements: {
    declarationPages: boolean;
    mvrReport: boolean;
    dashReport: boolean;
  };
  infoMessage?: string; // Optional informational message for this carrier
}

// Default file requirements for different scenarios
const DEFAULT_HOME_FILE_REQUIREMENTS = {
  declarationPages: true,
  mvrReport: false,
  dashReport: false,
} as const;

const DEFAULT_AUTO_FILE_REQUIREMENTS = {
  declarationPages: true,
  mvrReport: false,
  dashReport: false,
} as const;

// Helper to create carrier config with defaults
const createCarrier = (
  name: string,
  lineOfBusiness: 'Auto' | 'Home',
  options?: {
    displayName?: string;
    fileRequirements?: Partial<SpecialtyCarrierConfig['fileRequirements']>;
    infoMessage?: string;
  },
): SpecialtyCarrierConfig => ({
  name,
  displayName: options?.displayName || name,
  lineOfBusiness,
  fileRequirements: {
    ...(lineOfBusiness === 'Home'
      ? DEFAULT_HOME_FILE_REQUIREMENTS
      : DEFAULT_AUTO_FILE_REQUIREMENTS),
    ...options?.fileRequirements,
  },
  infoMessage: options?.infoMessage,
});

export const SPECIALTY_CARRIERS_CONFIG: SpecialtyCarrierConfig[] = [
  // Auto carriers
  createCarrier('Hagerty', 'Auto'),
  createCarrier('Aviva Elite', 'Auto', {
    fileRequirements: {
      mvrReport: true,
      dashReport: true,
    },
    infoMessage:
      'Motorhomes written with Aviva Elite require the MVR and DASH report.',
  }),
  createCarrier('Anderson McTague', 'Auto'),

  // Home/Property carriers
  createCarrier('Aviva Elite', 'Home'),
  createCarrier('Agile', 'Home'),
  createCarrier('Anderson McTague', 'Home'),
  createCarrier('Apollo', 'Home'),
  createCarrier('April Canada', 'Home'),
  createCarrier('April Marine', 'Home'),
  createCarrier('Burns & Wilcox', 'Home'),
  createCarrier('Cansure', 'Home'),
  createCarrier('Coast Underwriters', 'Home'),
  createCarrier('Excess Underwriting', 'Home'),
  createCarrier('Forward', 'Home'),
  createCarrier('Intact Public Entities', 'Home'),
  createCarrier('PAL', 'Home'),
  createCarrier('Premier Marine', 'Home'),
  createCarrier('SWG', 'Home'),
  createCarrier('Totten', 'Home'),
  createCarrier('Unique Risks', 'Home'),
  createCarrier('Angus Miller', 'Home'),
  createCarrier('Special Risk Insurance Managers (SRIM)', 'Home'),
  createCarrier('GroupOne', 'Home'),
];
